import jsPDF from "jspdf";
import { getJobByUserEmail } from "../firebase/firebase";

const generateAndSavePDF = (jobs) => {
  const pdf = new jsPDF();

  // Margin settings
  const marginTop = 10;
  const marginBottom = 10;

  pdf.text("Jobs Details - Report", 20, marginTop);
  pdf.text("Generated by Ahmed Anwer", 20, marginTop + 10);

  jobs.forEach((job, index) => {
    pdf.addPage();
    let yPos = marginTop;

    // Job Details
    pdf.text(`Job ${index + 1} Details---------`, 20, yPos);
    yPos += 10;
    pdf.text(`Title: ${job.job.title}`, 20, yPos);
    yPos += 10;
    pdf.text(`Description: ${job.job.description}`, 20, yPos);
    yPos += 20;
    pdf.text(`Experience Level: ${job.job.experienceLevel}`, 20, yPos);
    yPos += 10;
    pdf.text(`Salary: ${job.job.salary}`, 20, yPos);
    yPos += 10;
    pdf.text(`Type: ${job.job.type}`, 20, yPos);
    yPos += 10;
    pdf.text(`Requirements: ${job.job.requirements}`, 20, yPos);
    yPos += 10;
    pdf.text(`Responsibilities: ${job.job.responsibilities}`, 20, yPos);
    yPos += 10;
    pdf.text(`Deadline: ${job.job.applicationDeadline}`, 20, yPos);
    yPos += 10;

    // Company Details
    pdf.text(`Company Details---------`, 20, yPos);
    yPos += 10;
    pdf.text(`Name: ${job.company.displayName}`, 20, yPos);
    yPos += 10;
    pdf.text(`Email: ${job.company.email}`, 20, yPos);
    yPos += 10;
    pdf.text(`Contact No: ${job.company.userPhone}`, 20, yPos);
    yPos += 10;
    pdf.text(
      `Address: ${job.company.address.street}, ${job.company.address.city}, ${job.company.address.state}, ${job.company.address.country}, ${job.company.address.zip}`,
      20,
      yPos
    );
    yPos += 10;

    pdf.text("-----------------------------", 20, yPos);
    yPos += 10;
  });

  pdf.save("job_report.pdf");
};

export const handleGenerateReport = async (email) => {
  try {
    const jobs = await getJobByUserEmail(email);

    if (jobs) {
      generateAndSavePDF(jobs);
    } else {
      console.error("No jobs found for the specified email.");
    }
  } catch (error) {
    console.error("Error generating job report:", error);
  }
};
